import React from 'react';
import { connect } from 'react-redux';
import ConnectivitySnackBarLayout from '@chama/ui-components/components/ConnectivitySnackBarLayout';

const mapStateToProps = ({ apiConnectivity, firebase }) => {
  const apiDisconnected = !apiConnectivity.connected;
  const firebaseOfflineAfter = firebase.connectedAtLeastOnce
    ? // if we have connected to Firebase previously we will show a disconnected
      // warning after 1100 ms. Firebase client ping the Firebase server every
      // second, thus setting this to 1100 will guarantee at least two consecutive
      // pings have failed
      1100
    : // when we have not connected to Firebase yet (e.g. on initial load) we show
      // disconnected after 1500 ms
      5000;
  const timeSincePreviousFirebaseConnectionStatusChange =
    Date.now() - firebase.previousConnectionStatusChangeAt;
  const firebaseDisconnectedTooLong =
    !firebase.connected && timeSincePreviousFirebaseConnectionStatusChange > firebaseOfflineAfter;

  return {
    disconnected: apiDisconnected || firebaseDisconnectedTooLong,
  };
};

const ConnectivitySnackBar = props => {
  return <ConnectivitySnackBarLayout {...props} />;
};

export default connect(mapStateToProps)(ConnectivitySnackBar);



// WEBPACK FOOTER //
// ./src/containers/ConnectivitySnackBar.jsx